/* ==========================================================================
   ModalOrigins > Client
   ========================================================================== */

/* Import modules */
const { elementExist } = require('@bluekiri/alexandria/helpers/domHelpers');
const ModalClient = require('@bluekiri/alexandria-contrib-components/components/modal/client/js');
const OriginListCLient = require('@bluekiri/alexandria-contrib-components/components/origin-list/client/js');
const prototype = require('./prototype');
const config = require('./config');

/**
 * ModalOrigins component
 * @param {selector} String selector for the component in the client side.
 */
module.exports = function ModalOrigins(
    selector = `[data-component="Modal"][data-type="${config().type.modal}"]`,
    configuration = {}
) {
    if (elementExist(selector)) {
        /* Instance */
        const instance = Object.create(prototype);

        /* Element */
        instance.element = document.querySelector(selector);

        /* Config */
        instance.config = { ...config(), ...configuration };

        /* Origins */
        instance.origin = OriginListCLient(`${selector} [data-component="OriginList"]`, {
            ...configuration.origin
        });

        /* Modal */
        instance.modal = ModalClient(selector, {
            ...configuration.modal,
            type: config().type.modal,
            onOpen: () => instance.addEventListener(),
            onClose: () => instance.removeEventListener()
        });

        /* Clean */
        instance.removeEventListener();

        /* Return */
        return instance;
    }
};
